import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Button, Divider, Menu, Spin, Tabs, Typography } from "antd";
import ReadDataTable from "../../Common/ReadDataTable";
import ActionHeader from "../../Common/ActionHeader";
import DeleteWarningModal from "../../Common/DeleteWarningModal";
import "../../Common/Form.css";
import CourseEdit from "../CourseEdit";
import { getCourse } from "../../../services/courseService";

const { Title } = Typography;

const CoursePage = (props) => {
  const [course, setCourse] = useState({});
  const [formattedData, setFormattedData] = useState({});
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [status, setStatus] = useState({
    error: false,
    message: "",
  });

  const formatData = (data) => {
    return {
      general: [
        {
          label: "Title:",
          text: data.title,
        },
        {
          label: "Description:",
          text: data.description,
        },
        {
          label: "Duration (weeks):",
          text: data.duration,
        },
        {
          label: "Class Time (hours):",
          text: data.classTime,
        },
        {
          label: "Benefits:",
          text: data.benefits ? data.benefits.join("; ") : "",
        },
      ],
      costs: [
        { label: "Price:", text: data.price ?? "" },
        { label: "Currency:", text: data.currency ?? "" },
      ],
    };
  };

  const renderUnits = (units) => {
    return units.map((item) => {
      if (item)
        return (
          <Link to={"/unit/" + item.code}>
            <Button shape="round" type="ghost" style={{ margin: "3px" }}>
              {`${item.code}: ${item.description}`}
            </Button>
          </Link>
        );
    });
  };

  const actionMenu = (
    <Menu>
      <Menu.Item onClick={() => setIsEditModalVisible(true)}>Edit</Menu.Item>
      <Menu.Item onClick={() => setIsDeleteModalVisible(true)}>
        Delete
      </Menu.Item>
    </Menu>
  );

  const getData = () => {
    setIsLoading(true);
    getCourse({ code: props.match.params.courseId })
        .then((response) => {
          if (response.data.length !== 0) {
            const course = response.data.course;
            let data = formatData(course);
            setCourse(course);
            setFormattedData(data);
          } else {
            throw Error("This course offer does not exist!");
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setStatus({
            error: true,
            message: `${err}`,
          });
          setIsLoading(false);
        });
  }

  useEffect(() => {
    getData()
  }, [props.match.params.courseOfferId]);

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
          }}
        >
          <Spin />
        </div>
      ) : status.error ? (
        <div style={{ marginTop: "50px", textAlign: "center" }}>
          <Title>{status.message}</Title>
        </div>
      ) : (
        <>
          <DeleteWarningModal
            isVisible={isDeleteModalVisible}
            setIsVisible={setIsDeleteModalVisible}
            deleteLink={`${process.env.REACT_APP_BACKEND_URL}/`}
            params={{}}
          />

          <CourseEdit
            isOpen={isEditModalVisible}
            toggle={() => setIsEditModalVisible(false)}
            course={course}
          />

          <ActionHeader
            title={course.code + ": " + course.description}
            actionMenu={actionMenu}
          />

          {formattedData.general ? (
            <section className="grey-section">
              <Title level={5}>Details</Title>
              <ReadDataTable items={formattedData.general} />

              <Divider />

              {course.units ? (
                <div>
                  <Title level={5}>Units</Title>
                  {renderUnits(course.units)}
                </div>
              ) : null}

              <Divider />
              <Title level={5}>Cost</Title>
              <ReadDataTable items={formattedData.costs} />
            </section>
          ) : null}
        </>
      )}
    </div>
  );
};

export default withRouter(CoursePage);
